import { useCallback } from 'react'

import { useRouter } from 'next/compat/router'
import { useDispatch } from 'react-redux'

import { useQueryState } from 'nuqs'

import { openIncidentDrawer, setIncident } from '@/redux/ui/uiSlice'
import { INCIDENTS } from '@/utils/routes'

type openIncidentArgs = {
  incidentId: string
  displayId?: string | null
}

export const useOpenIncident = () => {
  const dispatch = useDispatch()
  const router = useRouter()
  const [, setDisplayId] = useQueryState('displayId')

  const openAlertIncidentDrawer = useCallback(
    (id: string) => {
      dispatch(setIncident({ id }))
      dispatch(openIncidentDrawer())
    },
    [dispatch]
  )

  const openIncident = useCallback(
    (args: openIncidentArgs) => {
      openAlertIncidentDrawer(args.incidentId)
      // `?displayId` names a different entity per route (a case on
      // /case-management — ENG-33742), so it is only ours to write on
      // /incidents. There it MUST be written: the incident drawer gates on it,
      // and a value left over from a previously opened incident holds the
      // drawer in a skeleton forever (ENG-35869).
      if (router?.pathname === INCIDENTS) setDisplayId(args.displayId ?? null)
    },
    [openAlertIncidentDrawer, router?.pathname, setDisplayId]
  )

  return { openIncident, setDisplayId, openAlertIncidentDrawer }
}
